import { CommonIn, CommonOut } from "./common";

export class FadeIn extends CommonIn {
    constructor(from, to, duration, easing, params) {
        super(from, to, duration, easing, params), this.keys = [ "opacity", "fillOpacity", "strokeOpacity" ], 
        this.from = {
            opacity: 0,
            fillOpacity: 0,
            strokeOpacity: 0
        };
    }
}

export class FadeOut extends CommonOut {
    constructor(from, to, duration, easing, params) {
        super(from, to, duration, easing, params), this.keys = [ "opacity", "fillOpacity", "strokeOpacity" ];
    }
}
//# sourceMappingURL=fade.js.map